export const camelToTitle = (v: string): string => {
	const result = v.replace(/([A-Z])/g, " $1");
	return result.charAt(0).toUpperCase() + result.slice(1);
};
